import { Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { COLORS } from "../../theme";

const defaultProps = {
  fontWeight: 600,
  color: '#222222', // Svart enligt styleguide
  fontFamily: 'Poppins, sans-serif',
  fontSize: '18px',
  sx: {}
};

export const H3 = ({ children, fontWeight, color, fontFamily, fontSize, sx }) => {
  return (
    <Typography 
      variant="h3" 
      sx={{ 
        fontWeight: fontWeight || 600, 
        color: color || '#222222', 
        fontFamily: fontFamily || 'Poppins, sans-serif', 
        fontSize: fontSize || { xs: '16px', md: '18px' },
        marginBottom: '0.75rem', // 12px default spacing
        ...(sx || {}) 
      }}
    >
      {children}
    </Typography>
  );
};

H3.propTypes = {
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sx: PropTypes.object
};

H3.defaultProps = defaultProps;

export default H3;
